import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../API/api.service';

@Injectable({
  providedIn: 'root'
})
export class ManufacturerService {

  constructor(public apiService: ApiService) { }

  addManufacturer(body: any): Observable<any> {
    return this.apiService.post('companymanufacturer/addcompanymanufacturer', body);
  }

  editManufacturer(body: any, param: any): Observable<any> {
    return this.apiService.put('companymanufacturer/updatecompanymanufacturerdetails', param, body);
  }

  getAllManufacturer(param: any): Observable<any> {
    return this.apiService.get(`companyagent/getcompanyagentmanufacturer/${param}`);
  }
  getManufacturerByStatusId(body: any): Observable<any> {
    return this.apiService.post('companyagent/getcompanyagentmanufacturerBystatusid', body);
  }
}
